import React from "react";
import LeftServiceSection2 from "./section2Left/LeftServiceSection2";
import RightServiceSection2 from "./section2Right/RightServiceSection2";

const ServiceSection2 = () => {
  return (
    <div id="act lg:w-screen">
      <div className="blog-services w-screen mt-12  lg:mx-auto lg:p-9 lg:flex justify-around ">
        <LeftServiceSection2 />
        <RightServiceSection2 />
      </div>
    </div>
  );
};

export default ServiceSection2;
